/**
 * Stable, case-insensitive comparator for the Plant Viewer's detail-page
 * lists. Mirrors the `toLower(coalesce(name, id))` ordering already used
 * server-side by `getPlantSites` / `getPlantComputeIndex`, so JS-sorted
 * `collect()` lists line up with their Cypher-sorted counterparts. Falls
 * back to the (non-lowercased) `id` when names tie so the order is stable
 * across renders.
 */
export function compareByNameThenId(
  a: { name?: string | null; id?: string | null },
  b: { name?: string | null; id?: string | null }
): number {
  const an = (a.name ?? a.id ?? '').toLowerCase()
  const bn = (b.name ?? b.id ?? '').toLowerCase()
  if (an !== bn) return an.localeCompare(bn)
  return (a.id ?? '').localeCompare(b.id ?? '')
}
